import * as THREE from 'three'
import { TimelineMax } from 'gsap/gsap-core'

export default class Audio {
    constructor(world) {
        this.world = world
        this.scene = this.world.scenes['scene-1']
        this.resources = this.world.stateController.resources.items
        this.time = this.world.time
        this.debug = this.world.debug
        this.camera = this.world.camera.perspectiveCamera
        this.sizes = this.world.sizes

        //Setup
        this.setDebug()
        this.setAudio()
    }

    setDebug() {
        // Debug
        if (this.debug.active) {
            this.audioFolder = this.debug.ui.addFolder('Audio')
            this.audioFolder.close()
        }
    }

    setAudio() {
        //Airplanes
        this.spitfire = this.world.world.models_world.airplane_spitfire
        this.b24 = this.world.world.models_world.airplane_b24

        //Positional audio
        this.listener = new THREE.AudioListener()
        this.camera.add( this.listener )

        // create an object for the sound to play from
        const sphere = new THREE.SphereGeometry( 0.2, 1, 1 )
        const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } )

        //////////////////////////////////////////////////////////////////////////////////////
        //ambient
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.ambient_sound = new THREE.Audio( this.listener )

        //assigning a sound
        this.ambient_sound.setBuffer( this.resources.ambient_sound )

        //sound settiambient
        this.ambient_sound.setLoop( true )
        this.ambient_sound.setVolume( 1 )
        this.ambient_sound.play()

        //////////////////////////////////////////////////////////////////////////////////////
        //ambient wind
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.ambient_wind_sound = new THREE.PositionalAudio( this.listener )
        this.ambient_wind_sound.panner.panningModel = 'equalpower'

        //assigning a sound
        this.ambient_wind_sound.setBuffer( this.resources.ambient_wind_sound )

        //sound settings
        this.ambient_wind_sound.setRefDistance( 10 )
        this.ambient_wind_sound.setMaxDistance( 1 )
        this.ambient_wind_sound.setRolloffFactor( 5 )
        this.ambient_wind_sound.setLoop( true )
        this.ambient_wind_sound.setVolume( 1 )
        this.ambient_wind_sound.play()

        //create an object for the sound to play from
        this.ambient_wind_sound_mesh = new THREE.Mesh( sphere, material )
        this.scene.add( this.ambient_wind_sound_mesh )
        this.ambient_wind_sound_mesh.add( this.ambient_wind_sound )
        this.ambient_wind_sound_mesh.visible = false
        this.ambient_wind_sound_mesh.position.set(0,18,0)

        //////////////////////////////////////////////////////////////////////////////////////
        //click
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.poi_click_sound = new THREE.Audio( this.listener )

        //assigning a sound
        this.poi_click_sound.setBuffer( this.resources.poi_click_sound )

        //sound settiambient
        this.poi_click_sound.setVolume( 1 )

        //////////////////////////////////////////////////////////////////////////////////////
        //hover
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.poi_hover_sound = new THREE.Audio( this.listener )

        //assigning a sound
        this.poi_hover_sound.setBuffer( this.resources.poi_hover_sound )

        //sound settiambient
        this.poi_hover_sound.setVolume( 0.4 )

        //////////////////////////////////////////////////////////////////////////////////////
        //poi zoom out
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.poi_zoom_out_sound = new THREE.Audio( this.listener )

        //assigning a sound
        this.poi_zoom_out_sound.setBuffer( this.resources.poi_zoom_out_sound )

        //sound settiambient
        this.poi_zoom_out_sound.setVolume( 1 )

        //////////////////////////////////////////////////////////////////////////////////////
        //poi zoom out
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.explosion_sound = new THREE.Audio( this.listener )

        //assigning a sound
        this.explosion_sound.setBuffer( this.resources.explosion_sound )

        //sound settiambient
        this.explosion_sound.setVolume( 0.5 )
        this.explosion_sound.detune = -1000

        //////////////////////////////////////////////////////////////////////////////////////
        //poi sound
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.poi_1_sound = new THREE.Audio( this.listener )
        this.poi_2_sound = new THREE.Audio( this.listener )
        this.poi_3_sound = new THREE.Audio( this.listener )
        this.poi_4_sound = new THREE.Audio( this.listener )
        this.poi_5_sound = new THREE.Audio( this.listener )
        this.poi_6_sound = new THREE.Audio( this.listener )
        this.poi_7_sound = new THREE.Audio( this.listener )
        this.poi_8_sound = new THREE.Audio( this.listener )

        //assigning a sound
        this.poi_1_sound.setBuffer( this.resources.poi_1_sound )
        this.poi_2_sound.setBuffer( this.resources.poi_2_sound )
        this.poi_3_sound.setBuffer( this.resources.poi_3_sound )
        this.poi_4_sound.setBuffer( this.resources.poi_4_sound )
        this.poi_5_sound.setBuffer( this.resources.poi_5_sound )
        this.poi_6_sound.setBuffer( this.resources.poi_6_sound )
        this.poi_7_sound.setBuffer( this.resources.poi_7_sound )
        this.poi_8_sound.setBuffer( this.resources.poi_8_sound )

        //sound settiambient
        this.poi_1_sound.setVolume( 1 )
        this.poi_2_sound.setVolume( 1 )
        this.poi_3_sound.setVolume( 1 )
        this.poi_4_sound.setVolume( 1 )
        this.poi_5_sound.setVolume( 1 )
        this.poi_6_sound.setVolume( 1 )
        this.poi_7_sound.setVolume( 1 )
        this.poi_8_sound.setVolume( 1 )

        //loop
        this.poi_1_sound.setLoop( true )
        this.poi_2_sound.setLoop( true )
        this.poi_3_sound.setLoop( true )
        this.poi_4_sound.setLoop( true )
        this.poi_5_sound.setLoop( true )
        this.poi_6_sound.setLoop( true )
        this.poi_7_sound.setLoop( true )
        this.poi_8_sound.setLoop( true )

        // Add the audio to a scene object
        const audioObject = new THREE.Object3D();
        audioObject.add(
            this.poi_1_sound,
            this.poi_2_sound,
            this.poi_3_sound,
            this.poi_4_sound,
            this.poi_5_sound,
            this.poi_6_sound,
            this.poi_7_sound,
            this.poi_8_sound,
            );
        this.scene.add(audioObject);

        // Create a TweenMax timeline for each sound
        this.poi_1_audio_in = new TimelineMax();
        this.poi_2_audio_in = new TimelineMax();
        this.poi_3_audio_in = new TimelineMax();
        this.poi_4_audio_in = new TimelineMax();
        this.poi_5_audio_in = new TimelineMax();
        this.poi_6_audio_in = new TimelineMax();
        this.poi_7_audio_in = new TimelineMax();
        this.poi_8_audio_in = new TimelineMax();

        this.poi_1_audio_out = new TimelineMax();
        this.poi_2_audio_out = new TimelineMax();
        this.poi_3_audio_out = new TimelineMax();
        this.poi_4_audio_out = new TimelineMax();
        this.poi_5_audio_out = new TimelineMax();
        this.poi_6_audio_out = new TimelineMax();
        this.poi_7_audio_out = new TimelineMax();
        this.poi_8_audio_out = new TimelineMax();

        //////////////////////////////////////////////////////////////////////////////////////
        //flare shot
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.flare_shot_sound = new THREE.Audio( this.listener )

        //assigning a sound
        this.flare_shot_sound.setBuffer( this.resources.flare_shot_sound )

        //sound settiambient
        this.flare_shot_sound.setVolume( 0.15 )

        //////////////////////////////////////////////////////////////////////////////////////
        //b24
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.b24_sound = new THREE.PositionalAudio( this.listener )
        this.b24_sound.panner.panningModel = 'equalpower'

        //assigning a sound
        this.b24_sound.setBuffer( this.resources.b24_sound )

        //sound settings
        this.b24_sound.setRefDistance( 2 )
        this.b24_sound.setMaxDistance( 0.03 )
        this.b24_sound.setRolloffFactor( 5 )
        this.b24_sound.setLoop( true )
        this.b24_sound.setVolume( 0.2 )
        this.b24_sound.play()

        //create an object for the sound to play from
        this.b24_sound_mesh = new THREE.Mesh( sphere, material )
        this.scene.add( this.b24_sound_mesh )
        this.b24_sound_mesh.add( this.b24_sound )
        this.b24_sound_mesh.visible = false

        //////////////////////////////////////////////////////////////////////////////////////
        //spitfire
        //////////////////////////////////////////////////////////////////////////////////////
        // create the PositionalAudio object (passing in the listener)
        this.spitfire_sound = new THREE.PositionalAudio( this.listener )
        this.spitfire_sound.panner.panningModel = 'equalpower'

        //assigning a sound
        this.spitfire_sound.setBuffer( this.resources.spitfire_sound )

        //sound settings
        this.spitfire_sound.setRefDistance( 2 )
        this.spitfire_sound.setMaxDistance( 0.03 )
        this.spitfire_sound.setRolloffFactor( 5 )
        this.spitfire_sound.setLoop( true )
        this.spitfire_sound.setVolume( 0.2 )
        this.spitfire_sound.play()

        //create an object for the sound to play from
        this.spitfire_sound_mesh = new THREE.Mesh( sphere, material )
        this.scene.add( this.spitfire_sound_mesh )
        this.spitfire_sound_mesh.add( this.spitfire_sound )
        this.spitfire_sound_mesh.visible = false

        //////////////////////////////////////////////////////////////////////////////////////
        //Debug
        //////////////////////////////////////////////////////////////////////////////////////
        if (this.debug.active) {
            this.audioFolder.add(this.ambient_sound, 'play').name('Sound ambient play')
            this.audioFolder.add(this.ambient_sound, 'pause').name('Sound ambient pause')

            this.audioFolder.add(this.ambient_wind_sound_mesh, 'visible').name('Sound wind mesh')
            this.audioFolder.add(this.ambient_wind_sound, 'play').name('Sound wind play')
            this.audioFolder.add(this.ambient_wind_sound, 'pause').name('Sound wind pause')

            this.audioFolder.add(this.spitfire_sound_mesh, 'visible').name('Sound spitfire mesh')
            this.audioFolder.add(this.spitfire_sound, 'play').name('Sound spitfire play')
            this.audioFolder.add(this.spitfire_sound, 'pause').name('Sound spitfire pause')

            this.audioFolder.add(this.b24_sound_mesh, 'visible').name('Sound b24 mesh')
            this.audioFolder.add(this.b24_sound, 'play').name('Sound b24 play')
            this.audioFolder.add(this.b24_sound, 'pause').name('Sound b24 pause')
        }  
    }

    update() {
        //linking the sound mesh to the animated object
        this.spitfire_sound_mesh.position.copy(this.spitfire.position)
        this.b24_sound_mesh.position.copy(this.b24.position)
    } 
}



